/* eslint-disable camelcase */
import * as THREE from 'three'
import { MapControls } from 'three/examples/jsm/controls/OrbitControls'

// fonts
import open_sans_regular_font from '../../../assets/json/fonts/open_sans_regular'
import font_awesome_5_free_solid from '../../../assets/json/fonts/font_awesome_5_free_solid'

const defaultOptions = {
  range_x: -1000,
  range_y: 1000,
  minZoomDistance: 200,
  width: 100,
  height: 100,
  backgroundColor: '#f8f8fa',
  isSelectionOn: false
}

const parseFonts = (fontLoader) => {
  const fontAwesome = fontLoader.parse(font_awesome_5_free_solid)
  const openSans = fontLoader.parse(open_sans_regular_font)
  return { fontAwesome, openSans }
}

const initThreeJsCanvas = (container, options = {}) => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ]

  window.isMobile = toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem)
  })

  options = { ...defaultOptions, ...options }
  const range = Math.max(options.range_x, options.range_y)
  const size = options.width
  const scale = (size * 1.5) / range
  const scene = new THREE.Scene()
  scene.background = new THREE.Color(options.backgroundColor)
  const camera = new THREE.PerspectiveCamera(75, 1, 0.1, 10000)
  camera.lookAt(new THREE.Vector3(0, 0, 0))
  camera.position.set(0, 0, size)
  const renderer = new THREE.WebGLRenderer({ antialias: true })

  renderer.setPixelRatio(window.devicePixelRatio)
  renderer.setSize(options.width, options.height)

  if (container.firstChild) {
    container.removeChild(container.firstChild)
  }
  container.appendChild(renderer.domElement)
  THREE.Cache.enabled = true
  const fontLoader = new THREE.FontLoader()

  const controls = new MapControls(camera, renderer.domElement)

  controls.screenSpacePanning = true
  controls.enableRotate = false
  controls.enablePan = true
  controls.minDistance = options.minZoomDistance
  controls.maxDistance = size
  controls.panBoundaries = new THREE.Vector4(
    (-370 * size) / 900,
    (370 * size) / 900,
    (-225 * size) / 900,
    (225 * size) / 900
  )

  // removed focus event because of auto triggering onmousedown event
  renderer.domElement.focus = null

  const fonts = parseFonts(fontLoader)
  const zoomSpeed = 0.1
  let zoom = 1
  function animate() {
    if (!animate.cancel) {
      controls.update()
      renderer.render(scene, camera)
      animate.cancel = true
    }
    window.requestAnimationFrame(animate)
  }
  animate.cancel = false
  animate.startAnimation = () => (animate.cancel = false)
  animate.cancelAnimation = () => (animate.cancel = true)
  animate()

  if (controls !== null) {
    controls.addEventListener('change', function () {
      animate.startAnimation()
    })
  }

  const controlsReset = () => {
    controls.reset()
    animate.startAnimation()
  }

  const updateCameraZoom = (zoom) => {
    camera.zoom = zoom
    camera.updateProjectionMatrix()
    animate.startAnimation()
  }

  const controlsZoomIn = () => {
    zoom += zoomSpeed
    updateCameraZoom(zoom)
  }

  const controlsZoomOut = () => {
    zoom -= zoomSpeed
    updateCameraZoom(zoom)
  }

  return {
    renderer,
    scene,
    camera,
    fonts,
    scale,
    controlsReset,
    controlsZoomIn,
    controlsZoomOut,
    startAnimation: animate.startAnimation,
    cancelAnimation: animate.cancelAnimation
  }
}

export { initThreeJsCanvas }
